import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from 'app/components/login/login.component';
import { ForbiddenComponent } from './components/login/forbidden/forbidden.component';
import { LegacyBypassComponent } from './components/login/legacyBypass.component';
import { FaqComponent } from 'app/components/faq/faq.component';
import { AuthGuardService } from '@sc/pas-common';
import { LegacyComponent } from './components/legacy/legacy.component';
import { MaintenanceComponent } from './components/login/maintenance/maintenance.component';
import { ClaimComponent } from 'app/components/claim/claim.component';
import { AutoPlanComponent } from 'app/components/auto-plan/auto-plan.component';
import { NewsComponent } from 'app/components/news/news.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SeachPolicyComponent } from './components/search-policy/search-policy.component';
import { AllQuotationsComponent } from './components/all-quotations/all-quotations.component';
import { RenovationsComponent } from './components/renovations/renovations.component';
import { ClientsDebtsComponent } from './components/clients-debts/clients-debts.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { SingleSignatureCreditComponent } from './components/single-signature-credit/single-signature-credit.component';
// tslint:disable-next-line:max-line-length
import { PolicyCancellationDetailsComponent } from './components/shared/notification/policy-cancellation-details/policy-cancellation-details.component';
import { ImpersonatedLoginComponent } from './components/login/impersonated-login/impersonated-login.component';
import { RetirementInsuranceComponent } from './components/retirement-insurance/retirement-insurance.component';
import { ImpersonationGuardService } from '@sc/pas-common';
import { SupportPasComponent } from './components/support-pas/support-pas.component';
import { EnvironmentGuard } from '@sc/pas-common';

const appRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'legado',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        component: LegacyComponent
    },
    {
        path: 'planes',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        component: AutoPlanComponent
    },
    {
        path: 'siniestros',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        component: ClaimComponent
    },
    {
        path: 'mi-cuenta',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        loadChildren: () => import('./modules/my-account/my-account.module').then(m => m.MyAccountModule),
    },
    {
        path: 'comisiones',
        canActivate: [AuthGuardService],
        loadChildren: () => import('./modules/commissions/commissions.module').then(m => m.CommissionsModule),
    },
    {
        path: 'comisiones-legado',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        loadChildren: () => import('./modules/commissions-legacy/commissions-legacy.module').then(m => m.CommissionsLegacyModule),
    },
    {
        path: 'info-protegida',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        loadChildren: () => import('./modules/protected-data/protected-data.module').then(m => m.ProtectedDataLoginModule),
    },
    {
        path: 'forbidden',
        component: ForbiddenComponent
    },
    {
        path: 'legacyToken',
        component: LegacyBypassComponent
    },
    {
        path: 'faq',
        component: FaqComponent
    },
    {
        path: 'maintenance',
        component: MaintenanceComponent
    },
    {
        path: 'aceptacion-poliza-digital',
        loadChildren: () => import('./modules/digital-policy/digital-policy.module').then(m => m.DigitalPolicyModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'sitio-seguro',
        loadChildren: () => import('@sc/sitio-seguro').then(m => m.SitioSeguroModule),
        canActivate: [AuthGuardService, ImpersonationGuardService],
    },
    {
        path: 'admin-leads',
        loadChildren: () => import('@sc/leads-admin').then(m => m.LeadsAdminModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'admin-leads/editar-contacto',
        loadChildren: () => import('@sc/leads-admin').then(m => m.LeadsContactModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'cotizador-integral-comercio',
        loadChildren: () => import('./modules/integral-trade/integral-trade.module').then(m => m.IntegralTradeModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'cotizador-accidentes-personales',
        loadChildren: () => import('./modules/personal-accidents/personal-accidents.module').then(m => m.PersonalAccidentsModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'denuncia-auto',
        loadChildren: () => import('./modules/ca7-claim/ca7-claim.module').then(m => m.Ca7ClaimModule),
        canActivate: [AuthGuardService, ImpersonationGuardService],
        data: {
            branch: 'auto'
        }
    },
    {
        path: 'denuncia-moto',
        loadChildren: () => import('./modules/ca7-claim/ca7-claim.module').then(m => m.Ca7ClaimModule),
        canActivate: [AuthGuardService, ImpersonationGuardService],
        data: {
            branch: 'moto'
        }
    },
    {
        path: 'denuncia-riesgos-varios',
        loadChildren: () => import('./modules/claim-oorr/claim-oorr.module').then(m => m.ClaimOORRModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'renovaciones',
        canActivate: [AuthGuardService, ImpersonationGuardService],
        loadChildren: () => import('./modules/renewals/renewals-view.module').then(m => m.RenewalsViewModule)
    },
    {
        path: 'auto',
        loadChildren: () => import('./modules/ca7-car/ca7-car.module').then(m => m.CarPolicyChangeModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'novedades',
        component: NewsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'creditos-sola-firma',
        component: SingleSignatureCreditComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'seguros-de-retiro',
        component: RetirementInsuranceComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'inicio',
        component: DashboardComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'buscador-poliza',
        component: SeachPolicyComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'mis-cotizaciones',
        component: AllQuotationsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'centro-renovaciones',
        component: RenovationsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'clientes-con-deudas',
        component: ClientsDebtsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'cobranzas',
        component: PaymentsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'cancelacion-poliza/:notificationId',
        component: PolicyCancellationDetailsComponent,
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'reclamos-terceros',
        loadChildren: () => import('@sc/thirdparty-claim').then(m => m.ThirdpartyClaimModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'notificacion-fuera-pauta',
        loadChildren: () => import('./modules/notification-underwriting/notification-underwriting.module')
            .then(m => m.NotificationUnderwritingModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'detalle-poliza',
        loadChildren: () => import('@sc/policy-detail').then(m => m.PolicyDetailsModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'auto-lite',
        loadChildren: () => import('./modules/car-quote-lite/car-quote-lite.module').then(m => m.CarQuoteLiteModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
      path: 'car-lite',
      loadChildren: () => import('@sc/car-lite').then(m => m.CarLiteModule),
      canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
      path: 'emision',
      loadChildren: () => import('@sc/car-issue').then(m => m.CarIssueModule),
      canActivate: [AuthGuardService]
    },
    {
        path: 'auto-unified',
        loadChildren: () => import('./modules/car-unified/car-unified.module').then(m => m.CarUnifiedModule)
    },
    {
        path: 'login-impersonificado',
        component: ImpersonatedLoginComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'soporte-pas',
        component: SupportPasComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'polizas',
        loadChildren: () => import('./modules/policy-lists/policy-lists.module').then(m => m.PolicyListsModule),
        canActivate: [AuthGuardService, ImpersonationGuardService]
    },
    {
        path: 'endoso',
        loadChildren: () => import('@sc/policy-change').then(m => m.PolicyChangeModule),
        canActivate: [ AuthGuardService ]
    },
    {
        path: '**',
        redirectTo: '/inicio'
    }
];

// Cambiar 'useHash' a 'true' si queremos usar hash en la URL
export const routing = RouterModule.forRoot(appRoutes);

